import { Address } from '../types';

const filterAddresses = (value: string, addresses: Address[]): Address[] => {
  if (!value) return addresses;

  const lowerInput = value.toLowerCase();
  return addresses.filter(
    (address) =>
      address.Title?.toLowerCase().includes(lowerInput) ||
      address.TypeTitle?.toLowerCase().includes(lowerInput) ||
      address.Line1?.toLowerCase().includes(lowerInput) ||
      address.City?.toLowerCase().includes(lowerInput) ||
      address.Province?.toLowerCase().includes(lowerInput) ||
      address.PatrolType?.toLowerCase().includes(lowerInput),
  );
};

export default filterAddresses;
